import { useEffect, useState } from "react"
import { useApp } from "../../../contexts"
import { format } from 'date-fns'
import api from "../../../services/api"
import Filters from "../../components/Filters"
import getStringParams from "../../../helpers/data/getStringParams"
import { Checkbox, Text, Card, CREToolTab, IconButton, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, Button } from "../../components"
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import LGPDAccordionContactDetails from "../../components/lgpd/LGPDAccordionContactDetails"

const INITIAL_QUERY = {
    filters: [
        {
            field: 'tipo_contato',
            condition: 'equal',
            value: 'Física'
        }
    ],
    queryString: '',
        // data_atualizacao: [{
        //     condition: 'bt',
        //     value: '2022-03-28 2022-03-30'
        // }],
        // data_cadastro: [{
        //     condition: 'lte',
        //     value: '2022-01-01'
        // }],
    sort: 'data_atualizacao;desc',
    fields: ['id_contato', 'nome_contato', 'data_atualizacao', 'data_cadastro'],
    page: 0,
    limit: 100
}

const UsersList = () => {

    const [contacts, setContacts] = useState([])
    const [query, setQuery] = useState(INITIAL_QUERY)
    const [selectedAll, setSelectedAll] = useState(false)
    const { setLoading, showDialog } = useApp();

    useEffect(() => {
        loadContacts()
    }, [query])

    const contactDetails = (contact) => {

        showDialog({
            title: `Anonimização LGPD - ${contact.nome_contato}`,
            component: LGPDDetails(contact.id_contato),
            fullWidth: true,
            confirmLabelButton: 'Anonimizar'
        })
    }

    const LGPDDetails = (contactId) => (<>
        {/* <Text>{`Todos os dados cadastrais, e-mails, endereços, grupos entre outros dados serão perdidos`}</Text> */}
        <LGPDAccordionContactDetails contactId={contactId} />
    </>)

    function handleSearchButton(value) {
        setQuery({
            ...query,
            query: value,
            page: 0
        })
    }
    
    const loadContacts = async () => {
        setLoading(true)
        const response = await api.get(`/contact?${getStringParams(query)}`)
        setContacts(response.data)
        setLoading(false)
    }

    const handleCheck = (index, checked) => {

        let newContacts = contacts
        newContacts[index] = {
            ...contacts[index],
            checked
        }
        setContacts([...newContacts])
    }

    const handleSelectAll = () => {
        const newContacts = contacts.map(contact => {
            return { ...contact, checked: !selectedAll }
        })

        setSelectedAll(!selectedAll)
        setContacts([...newContacts])
    }

    const sendContactToCretool = (contact) => {

        // if(window.location.origin !== 'https://viewer.cretool.com.br'){
        let event = new CustomEvent('getCretoolEvent', { detail: { params: [contact.id_contato, contact.nome_contato], controller: "contato", func: "mostrarTabContato" } });
        window.parent.document.dispatchEvent(event);
        // }else{
        // }
    }

    return (
        <CREToolTab title='LGPD - Controle de Contatos' handleSearchButton={handleSearchButton}>
            <Filters handleSearchButton={handleSearchButton} />
            <Card>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow >
                                {/*<TableCell padding="checkbox" sx={{ paddingTop: 20 }}>
                                    <Checkbox
                                        color="primary"
                                        checked={selectedAll}
                                        onChange={handleSelectAll}
                                    />
                                   
                                </TableCell> */}
                                <TableCell>
                                    <Text style={{ fontWeight: '700' }}>ID</Text>
                                </TableCell>
                                <TableCell sx={{ flex: 1 }}>
                                    <Text style={{ fontWeight: '700' }}>Nome do Contato</Text>
                                </TableCell>
                                <TableCell align='center'>
                                    <Text style={{ fontWeight: '700', textAlign: 'center' }}>Data de Cadastro</Text>
                                </TableCell>
                                <TableCell align='center'>
                                    <Text style={{ fontWeight: '700', textAlign: 'center' }}>Data de Atualização</Text>
                                </TableCell>
                                <TableCell align='center'>
                                    <Text style={{ fontWeight: '700', textAlign: 'center' }}>Detalhes</Text>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {contacts.map((contact, index) => {
                                const { checked = false } = contact
                                return (
                                    <TableRow key={`contact${index}.${contact.id_contato}`}>
                                        {/*<TableCell padding="checkbox">
                                            <Checkbox
                                                color="primary"
                                                checked={checked}
                                                onChange={() => handleCheck(index, !checked)}
                                            />
                               
                                        </TableCell> */}
                                        <TableCell align='center'>{contact.id_contato}</TableCell>
                                        <TableCell sx={{ flex: 1 }}><Button sx={{ cursor: 'pointer' }} onClick={() => contactDetails(contact)}>{contact.nome_contato}</Button></TableCell>
                                        <TableCell align='center'>{format(new Date(contact.data_cadastro), 'dd/MM/yyyy')}</TableCell>
                                        <TableCell align='center'>{format(new Date(contact.data_atualizacao), 'dd/MM/yyyy')}</TableCell>
                                        <TableCell align='center'>
                                            <IconButton onClick={() => sendContactToCretool(contact)} color="primary" aria-label="Anonimizar Contato" sx={{ margin: 0 }} >
                                                <ManageSearchIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Card>
        </CREToolTab>
    )
}

export default UsersList